import { render, staticRenderFns } from "./Fournisseurs.vue?vue&type=template&id=beccc9fa&"
import script from "./Fournisseurs.vue?vue&type=script&lang=js&"
export * from "./Fournisseurs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports